import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { BlockColorField } from "./block.interfaces";

export const useDefaultColors = () => {
    const { t } = useI18n();

    const colorDefaults = computed<Record<BlockColorField["value"], BlockColorField>>(() => ({
        background: {
            value: "background",
            type: "color",
            name: t("shared.colors.background"),
            default: "var(--et-colors-background)",
        },
        text: {
            value: "text",
            type: "color",
            name: t("shared.colors.text"),
            default: "var(--et-colors-text)",
        },
        cardBackground: {
            value: "cardBackground",
            type: "color",
            name: t("shared.colors.card_background"),
            default: "var(--et-colors-card-background)",
        },
        cardText: {
            value: "cardText",
            type: "color",
            name: t("shared.colors.card_text"),
            default: "var(--et-colors-card-text)",
        },
        brand: {
            value: "brand",
            type: "color",
            name: t("shared.colors.brand"),
            default: "var(--et-colors-brand)",
        },
        border: {
            value: "border",
            type: "color",
            name: t("shared.colors.border"),
            default: "var(--et-colors-border)",
        },
    }));

    return { colorDefaults };
};
